import React from 'react';
import { Helmet } from 'react-helmet';


function Charset() {
    return (
        <Helmet>
            <meta charSet="utf-8" />
            <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
            <title>marcaki</title>
            <meta
                name="viewport"
                content="width=device-width, initial-scale=1, shrink-to-fit=no"
            />
        </Helmet>
    );
}
export default Charset;
